import { z } from 'zod';

/**
 * `Account.status` — mirror of {@link walletStatusSchema}.
 *
 * Kept as a separate enum (rather than aliased) so the legacy
 * `Wallet` and the new `Account` can diverge later without forcing a
 * cross-collection rename. Identical value set today.
 */
export const accountStatusSchema = z.enum(['active', 'suspended', 'in_review']);
export type AccountStatus = z.infer<typeof accountStatusSchema>;
